import { Component, OnInit, Inject, Input, Output, EventEmitter, ViewChild, HostListener, SimpleChanges, ElementRef } from '@angular/core';
import { OwlOptions, SlidesOutputData, CarouselComponent, CarouselModule } from 'ngx-owl-carousel-o';
import { AssetsService } from "../../core/services/assets.service";
import { PlaylistService, UserService } from '../../core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../core/services/common.service';
import { VideoPlayerService } from '../../core/services/videoPlayerService';
import { EventTrackingService } from '../../page-services/google/event-tracking.service';
import { LoginRegisterComponent } from '../../auth/login-register/login-register.component';
import { ImageManipulationComponent } from '../../core/components/image-manipulation/image-manipulation.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-banner-slider',
  imports: [LoginRegisterComponent,CarouselModule,ImageManipulationComponent,CommonModule,TranslateModule],
  templateUrl: './banner-slider.component.html',
  styleUrl: './banner-slider.component.css'
})

export class BannerSliderComponent {

  @Input() owlOption!: OwlOptions;
  @Input() data: any = {};
  @Input() page_view:any;
  @Output() deleteRecentWatch: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('closeAddtoWatchListModal') closeAddtoWatchListModal!:ElementRef;
  @ViewChild('addToWatchListSuccessFromBanner') addToWatchListSuccessFromBanner!:ElementRef;
  @ViewChild('owlCarousel') owlCarousel!: CarouselComponent;
  @ViewChild('thumbnailCarousel') thumbnailCarousel!: CarouselComponent;
  @ViewChild('loginContent') loginContent!: ElementRef;
  public bannerResult: any = null;
  public show_banners: boolean = false;;
  streamInfo: any;
  public userInfo: any;
  username: string = '';
  playListId: string = '';
  notFoundImg: any;
  language: any;

  playermodal: any = [];
  isPreviewVideoMuted: boolean = true;
  timeDuration: any;
  isVideoPlaying: any[] = [];
  activeSlideIndex: number = 2;
  currentPlayedIndex!: number;
  addBefourVideo1Second: any = [];
  thumbnailCarouselOptions!: OwlOptions;
  HeroBanner!: OwlOptions;
  animationDuration:any;
  currentSlideIndex: number = 0;
  changeTimeout: any;
  isAuthenticated: boolean = false;
  isCarouselInitialized: boolean = false;
  isThumbnailCarouselInitialized: boolean = false;
  currentThumbnailIndex: number = 0;
  isVideoPlayingTimeout: any;
  isSubscribeAnimation: boolean = true;
  subscribeAnimationTimeout: any;
  private previewSubscription: any = null;
  assetDetail: any;
  isMobile: boolean = false;
  constructor(
    public AssetsService: AssetsService,
    public UserService: UserService,
    private modalService: NgbModal,
    public playListService: PlaylistService,
    public commonService: CommonService,
    @Inject(DOCUMENT) private document: Document,
    private googleEvent: EventTrackingService,
    private router: Router,
    public VideoPlayerService: VideoPlayerService,
    private route: ActivatedRoute,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
   
    if (changes['data'].currentValue?.length > 0) {
      const timeout = localStorage.getItem('reload') == 'true' ? 0 : 500;
      setTimeout(() =>{
        this.bannerResult = changes['data'].currentValue;
        
      if (this.userInfo) {
        this.getAssetDetail(0);
      }

      if (this.bannerResult?.length === 1)
        this.owlOption = { ...this.owlOption, loop: false }
      
      if (this.bannerResult?.length <= 4)
        this.thumbnailCarouselOptions = { ...this.thumbnailCarouselOptions, loop: false }

      setTimeout(() => {
        const allBannerSlides:any = document.querySelectorAll('.home_slide .owl-item');
        for (let i = 0; i < allBannerSlides.length; i++) {
          if (allBannerSlides[i].classList.contains('cloned') == true && allBannerSlides[i].querySelector('.trailer_video .video-js')) {
            allBannerSlides[i].querySelector('.trailer_video .video-js').removeAttribute('id');
            const gId = allBannerSlides[i].querySelector('.trailer_video .video-js');
          }
        }
  
        this.playPreviewVideo(0);
      }, 0);
      },timeout)
    }else {
      setTimeout(() => {
        this.show_banners = true;
      }, 1000);
      
    }
    // this.playPreviewVideo(0);
  }

  ngOnInit() {
    this.checkScreen();
    window.addEventListener('resize', this.checkScreen.bind(this));
    this.isAuthenticated = !!localStorage.getItem('isAuthenticated');
    this.thumbnailCarouselOptions = {
      loop: true,
      dots: false,
      margin: 10,
      nav: true,
      autoplay: false,
      autoplayHoverPause: true,
      navText: [
        "<img src='assets/img/Icon/left-arrow.svg'>",
        "<img src='assets/img/Icon/right-arrow.svg'>",
      ],
      items: 4
    };


    this.HeroBanner = {
      items: 1,
      loop : true,
      responsive: {
        768: {
          dots : true,
          margin : 0
        }
  },
    };

    $(".dark").addClass("homeAndDetailPage");
    this.language = this.commonService.languageChange();
    this.notFoundImg = "landscape";
    if (localStorage.getItem('userInfo')) {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo')!);
      this.username = this.userInfo.result.user.username;
      this.playListId = localStorage.getItem('playListId')!;
    }
    // this.bannerResult = this.data;
    //let isIos = /iPhone/i.test(window.navigator.userAgent)
    if (this.userInfo) {
      // this.getWatchList();
    }
    // if (isIos) {
    //   this.owlOption.autoplay = false;
    //   delete this.owlOption.responsive['0'].autoplayTimeout;
    //   delete this.owlOption.responsive['600'].autoplayTimeout;
    //   delete this.owlOption.responsive['1000'].autoplayTimeout;
    //   delete this.owlOption.responsive['1300'].autoplayTimeout;
    // }

    this.owlOption = { ...this.owlOption, autoplay: false }

  }

  ngOnDestroy() {
    this.clearCurrentSlide(this.currentSlideIndex);
    this.playermodal.forEach((item: any) => item?.dispose());
  }

  private clearCurrentSlide(index: number) {
    if (this.changeTimeout) {
      clearTimeout(this.changeTimeout);
      this.changeTimeout = null;
    }
    if (this.isVideoPlayingTimeout) {
      clearTimeout(this.isVideoPlayingTimeout);
      this.isVideoPlayingTimeout = null;
    }
    if (this.previewSubscription) {
      this.previewSubscription.unsubscribe();
      this.previewSubscription = null;
    }
    if (this.playermodal[index]) {
      this.playermodal[index].pause();
      this.playermodal[index].muted(true);
    }
    this.isVideoPlaying[index] = false;
  }

  onCarouselInitialized(event: SlidesOutputData) {
    if (this.isCarouselInitialized)
      return;
    
    this.isCarouselInitialized = true;

    // setTimeout(() => {
    //   const allBannerSlides = document.querySelectorAll('.home_slide .owl-item');
    //   for (let i = 0; i < allBannerSlides.length; i++) {
    //     if (allBannerSlides[i].classList.contains('cloned') == true && allBannerSlides[i].querySelector('.trailer_video .video-js')) {
    //       allBannerSlides[i].querySelector('.trailer_video .video-js').removeAttribute('id');
    //       const gId = allBannerSlides[i].querySelector('.trailer_video .video-js');
    //     }
    //   }

    //   this.playPreviewVideo(0);
    // }, 0);
  }

  onCarouselTranslated(event: SlidesOutputData) {
    if (event.startPosition === this.currentSlideIndex) {
      return;
    }

    this.clearCurrentSlide(this.currentSlideIndex);

    this.currentSlideIndex = event.startPosition!;
    this.thumbnailCarousel.to(this.currentSlideIndex.toString());
    this.playPreviewVideo(this.currentSlideIndex);
    if(this.bannerResult?.length <= 4){
      this.document.querySelectorAll('.slider_thumbnail .owl-item').forEach(item => {
        item.classList.remove('thumbnail-active');
      });
      
      let activeThumbnailSlides = this.document.querySelectorAll('.slider_thumbnail .owl-item.active');
      activeThumbnailSlides[this.currentSlideIndex].classList.add('thumbnail-active');
    }
    if (!this.bannerResult[this.currentSlideIndex]?.['assetDetail'] && this.userInfo) {
      this.getAssetDetail();
    }
  }

  onThumbnailCarouselInitialized(event: SlidesOutputData) {
    if (this.isThumbnailCarouselInitialized)
      return;
    
    this.isThumbnailCarouselInitialized = true;
    setTimeout(() => {
      let activeThumbnailSlides = this.document.querySelectorAll('.slider_thumbnail .owl-item.active');
      activeThumbnailSlides[0].classList?.add('thumbnail-active');
    }, 0);
  }

  onThumbnailCarouselTranslated(event: SlidesOutputData) {
    if (event.startPosition === this.currentThumbnailIndex) {
      return;
    }
    this.owlCarousel.to(event.startPosition!.toString());
    this.currentThumbnailIndex = event.startPosition!;
    this.document.querySelectorAll('.slider_thumbnail .owl-item').forEach(item => {
      item.classList.remove('thumbnail-active');
    });
    let activeThumbnailSlides = this.document.querySelectorAll('.slider_thumbnail .owl-item.active');
    activeThumbnailSlides[0].classList.add('thumbnail-active');
  }

  goToNextSlide() {
    this.owlCarousel.next();
    this.thumbnailCarousel.next();
  }

  getAssetDetail(bannerIndex?: number) {
    let index = bannerIndex || this.currentSlideIndex
    let assetDetail = {
      "code": this.bannerResult[index].code,
      "type": this.bannerResult[index].type || ''
    }
    let urlEncodedDetail = this.UserService.convertoJSONToUrlEncoded(assetDetail);
    this.AssetsService.getAssetDetail(urlEncodedDetail).subscribe(assetDetailRes => {
      this.bannerResult[this.currentSlideIndex]['assetDetail'] = assetDetailRes.result;
      this.bannerResult[this.currentSlideIndex].assetDetail.slug = this.bannerResult[this.currentSlideIndex].slug;
      
    }, (error) => {
      console.error('error fetching asset detail: ', error);
    });
  }

  playPreviewVideo(index: number) {
    if (this.bannerResult[index]?.is_preview != '1') {
      // No preview: show image for 5s then advance
      this.changeTimeout = setTimeout(() => {
        this.changeTimeout = null;
        this.goToNextSlide();
      }, 5000);
      return;
    }

    // Fire the API call and the 5-second image timer in parallel.
    // Video starts only when BOTH have completed, so the image is always
    // visible for at least 5 seconds while the network round-trip is "free".
    let imageTimerDone = false;
    let apiResult: any = null;
    let apiDone = false;

    const tryStartVideo = () => {
      if (!imageTimerDone || !apiDone) return;
      if (index !== this.currentSlideIndex) return;

      if (!apiResult) {
        this.goToNextSlide();
        return;
      }

      const cf = apiResult.cloud_front;
      if (!cf?.cloudfront_key_pair_id || !cf?.video_url || !cf?.cloudfront_policy || !cf?.cloudfront_signature) {
        this.goToNextSlide();
        return;
      }

      this.setCookie("CloudFront-Key-Pair-Id", cf.cloudfront_key_pair_id.trim(), 1);
      this.setCookie("CloudFront-Policy", cf.cloudfront_policy.trim(), 1);
      this.setCookie("CloudFront-Signature", cf.cloudfront_signature.trim(), 1);

      let videoPlayUrl = cf.video_url;
      const src_type: any = window.location.hostname === 'localhost' ? 'a' : '';
      if (src_type) {
        videoPlayUrl = "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4";
      }

      const sources = [{ src: videoPlayUrl, type: src_type ? "video/mp4" : "application/x-mpegURL" }];

      if (!this.playermodal[index]) {
        this.playermodal[index] = videojs("bannervideo" + index, {
          sources,
          controls: false,
          autoplay: true,
          withCredentials: true,
          crossDomain: true,
          fluid: true,
          muted: true,
          controlBar: { children: [] },
        });
        const encodedImageUrl = this.commonService.compressImgUrl(
          this.bannerResult[index].image_landscape, { width: 1280, height: 720 }, 'landscape'
        );
        this.playermodal[index].poster(encodedImageUrl);
        this.playermodal[index].on("error", () => {
          if (this.isVideoPlayingTimeout) clearTimeout(this.isVideoPlayingTimeout);
          this.isVideoPlaying[index] = false;
          if (index === this.currentSlideIndex) this.goToNextSlide();
        });
      } else {
        // Player already exists for this slide — update source and replay
        this.playermodal[index].src(sources);
      }

      this.playermodal[index].ready(() => {
        if (index !== this.currentSlideIndex) return;
        if (this.playermodal[index].error()) {
          if (this.isVideoPlayingTimeout) clearTimeout(this.isVideoPlayingTimeout);
          this.isVideoPlaying[index] = false;
          this.goToNextSlide();
          return;
        }
        this.playermodal[index].currentTime(0);
        this.playermodal[index].play();
        this.isPreviewVideoMuted = true;
        this.playermodal[index].muted(true);
        this.isVideoPlayingTimeout = setTimeout(() => { this.isVideoPlaying[index] = true; }, 1000);
        this.playermodal[index].off("ended");
        this.playermodal[index].on("ended", () => {
          this.playermodal[index].pause();
          if (index === this.currentSlideIndex) this.goToNextSlide();
        });
      });
    };

    // 5-second image display timer
    this.changeTimeout = setTimeout(() => {
      this.changeTimeout = null;
      imageTimerDone = true;
      tryStartVideo();
    }, 5000);

    // Parallel API call to pre-fetch the stream URL
    const assetInfo = this.UserService.convertoJSONToUrlEncoded({ code: this.bannerResult[index].code });
    this.previewSubscription = this.VideoPlayerService.playPreview(assetInfo).subscribe({
      next: (playObj) => {
        this.previewSubscription = null;
        apiResult = playObj.result;
        apiDone = true;
        tryStartVideo();
      },
      error: () => {
        this.previewSubscription = null;
        apiDone = true;  // apiResult stays null → goToNextSlide() in tryStartVideo
        tryStartVideo();
      }
    });
  }

  trackByBannerId(index: number, banner: any): string {
    return banner.id; // Track by the unique `id` property of the branch
  }

  handleThumbnailClick(thumbnailIndex: number) {
    this.owlCarousel.to(thumbnailIndex.toString());
    this.thumbnailCarousel.to(thumbnailIndex.toString());
  }

  addRemoveFromWatchlist(item: any, event: Event) {
    // button.disabled = true;
    event.stopPropagation();

    if (!this.isAuthenticated) {
      this.openLoginModal();
      return;
    }

    if (!item?.is_watchlist_added || item?.is_watchlist_added == 0) {
      this.googleEvent.eventEmitter("Watchlist" , "Watchlist" , this.username+'-'+item.code+'-'+item.name,0,this.username , this.username+'-'+item.code+'-'+item.name);
      let params = {
        type: item.type,
        code: item.code,
      };
      this.AssetsService.addToWatchList(params).subscribe(
        (data) => {
          if (data.response_code === 200 || data.response_code === 201) {
            item.is_watchlist_added = 1;
            // this.addToWatchlist.emit(item);
          }
          // button.disabled = false;
        },
        (error) => {
          console.error('Error adding to watchlist:', error);
          // button.disabled = false;
        }
      );
    } else {
      let params = {
        code: [item.code],
      };
      this.AssetsService.deleteFromWatchlist(params).subscribe(
        (data) => {
          if (data.response_code === 200 || data.response_code === 201) {
            item.is_watchlist_added = 0;
            // this.removeFromWatchlist.emit(item);
          }
          // button.disabled = false;
        },
        (error) => {
          console.error('Error deleting from watchlist:', error);
          // button.disabled = false;
        }
      );
    }
  }

  openLoginModal() {
    this.modalService.open(this.loginContent, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    }, (reason) => {
    });
  }

  muteUnmutePreview(isMuted: boolean, index:any, event: Event) {
    event.stopPropagation();
    if (isMuted) {
      this.isPreviewVideoMuted = false;
      var muted = this.playermodal[index].muted(false);
    } else {
      this.isPreviewVideoMuted = true;
      var muted = this.playermodal[index].muted(true);
    }
  }

  // playVideo(item, content, loginContent) {
  //   if (this.userInfo) {
  //     this.streamInfo = item;
  //     this.streamInfo['stop'] = this.streamInfo.stop ? this.streamInfo : 0;
  //     this.streamInfo['genre'] = this.streamInfo?.asset_detail?.genre;
  //     this.commonService.goToDetail(this.streamInfo, this.page_view);
  //   }
  //   else {
  //     this.commonService.setBeforeLoginState(item);
  //     // this.router.navigateByUrl('/login');
  //     this.modalService.open(loginContent, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
  //     }, (reason) => {
  //     });
  //   }
  // }

  playVideo(event: MouseEvent,item:any, loginContent:any,full_screen=false) {
    event.stopPropagation();  // Prevent the event from bubbling up
    if (this.userInfo) {
      this.streamInfo = item;
      this.streamInfo['stop'] = this.streamInfo.stop ? this.streamInfo : 0;
      this.streamInfo['genre'] = this.streamInfo?.asset_detail?.genre;
      this.streamInfo['full_screen'] = full_screen;

      this.commonService.goToDetail(this.streamInfo, this.page_view);
      // if (!full_screen || (item.content_availability.toLowerCase() == 'free' || item.content_availability.toLowerCase() == 'paid' && this.streamInfo?.assetDetail?.is_pack_active == 1)) {
      //   this.commonService.goToDetail(this.streamInfo, this.page_view);
      // } else {
      //   this.router.navigateByUrl('/subscribe');
      // }
    }
    else {
      // this.commonService.setBeforeLoginState(item);
      if (item) {
        item.full_screen = full_screen;
      }
      this.modalService.open(loginContent, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      }, (reason) => {
      });
      this.commonService.setDetailRedirectParams(item);
    }
  }
  
  setCookie(cname:any, cvalue:any, exdays:any) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  strToLower(str: string) {
    return str?.toLowerCase();
  }

  strToString(str:any) {
    return str?.toString();
  }

  shortText(text: string): string {
    return text.length > 180 ? text.slice(0, 180) + '....' : text;
  }

  checkScreen() {
    this.isMobile = window.innerWidth <= 768; // mobile breakpoint
  }
}